

export type EmailComponentValue = string | null;
